import * as Factory from 'factory.ts'
import faker from 'faker'

import { PayCardReconciliationStatus } from '@webapp/models/enums/PayCardReconciliationStatus'
import { AccountMock } from './account.factory'
import { AttachmentMock } from './attachment.factory'
import { SimplePayCardMock } from './payCard.factory'
import { PayCardholderMock } from './payCardholder.factory'
import { PayFundMock } from './payFund.factory'
import { PayCardVendorMock } from './vendor.factory'
import { PayCardTransactionStatus } from '../../models/enums/PayCardTransactionStatus'
import { TransactionAuthorizationStatus } from '../../models/enums/TransactionAuthorizationStatus'
import { TransactionType } from '../../models/enums/TransactionType'
import { type PayCardTransaction } from '../../models/PayCardTransaction'

export const PayCardTransactionMock =
  Factory.Sync.makeFactory<PayCardTransaction>({
    id: Factory.each(() => faker.random.number()),
    external_id: `iauth_${faker.random.alphaNumeric(24)}`,
    note: Factory.each(() => faker.random.words()),
    vendor: Factory.each(() => PayCardVendorMock.build()),
    currency: 'USD',
    amount: Factory.each(() => faker.finance.amount()),
    vendor_currency: 'USD',
    vendor_amount: faker.finance.amount(),
    status: PayCardTransactionStatus.capture,
    authorization_status: TransactionAuthorizationStatus.closed,
    authorization_datetime: Factory.each(() =>
      faker.date.past(10).toISOString()
    ),
    transaction_datetime: Factory.each(() => faker.date.past(10).toISOString()),
    allocation_datetime: Factory.each(() => {
      return faker.random.boolean() === true
        ? faker.date.past(10).toISOString()
        : null
    }),
    card: Factory.each(() => SimplePayCardMock.build()),
    attachments: [],
    type: TransactionType.Spend,
    reconciliation_status: PayCardReconciliationStatus.PENDING,
    account: Factory.each(() => {
      return faker.random.boolean() === true ? AccountMock.build() : null
    }),
    cardholder: Factory.each(() => PayCardholderMock.build()),
    linked_authorization: `iauth_${faker.random.alphaNumeric(24)}`,
  })
    .withDerivation2(
      ['allocation_datetime', 'type'],
      'fund',
      (dateTime: string, type: TransactionType) => {
        return dateTime !== null || type === TransactionType.Credit
          ? PayFundMock.build()
          : null
      }
    )
    .withDerivation2(
      ['reconciliation_status', 'type'],
      'attachments',
      (
        reconciliationStatus: PayCardReconciliationStatus,
        type: TransactionType
      ) => {
        return reconciliationStatus === PayCardReconciliationStatus.REVIEWED &&
          type === TransactionType.Spend
          ? AttachmentMock.buildList(2)
          : []
      }
    )
